<template>
  <tk-modal
    v-if="showModal"
    :no-show-header="true"
    close-text="閉じる"
    class="favoriteModal"
    @close="close"
  >
    <div
      class="favoriteModal_body"
      :class="{ '-error': !isSucceededRegister }"
    >
      <template v-if="isSucceededRegister">
        <p class="favoriteModal_message">
          組み合わせを保存しました。<br />下図のボタンから、保存した組み合わせをご覧いただけます。
        </p>
        <picture>
          <source
            media="(max-width: 657px)"
            srcset="https://www.tabikobo.com/tour/media/tabi_sp_files/img/common/fav_guide.jpg?180723 2x"
          >
          <tk-image
            class="favoriteModal_img"
            :image-path="'https://www.tabikobo.com/tour/media/tabi_files/img/common/fav_guide.jpg?180723'"
            alt="お気に入り商品を見る"
          />
        </picture>
      </template>
      <p
        v-else-if="isFavRegistered"
        class="favoriteModal_message"
      >
        問題が発生し、削除ができませんでした。<br />時間をおいてから再度お試しください
      </p>
      <p
        v-else
        class="favoriteModal_message"
      >
        問題が発生し、保存ができませんでした。<br />時間をおいてから再度お試しください
      </p>
      <tk-button
        class="favoriteModal_btn"
        @click="close"
      >
        閉じる
      </tk-button>
    </div>
  </tk-modal>
</template>

<script>
import TkModal from '../TkGlobalModal/TkGlobalModal'
import TkButton from '../TkButton/TkButton'
import TkImage from '../TkImage/TkImage'
export default {
  name: 'TkFavoriteModal',
  components: {
    TkModal,
    TkImage,
    TkButton,
  },
  props: {
    isSucceededRegister: {
      type: Boolean,
      required: true,
    },
    isFavRegistered: {
      type: Boolean,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.favoriteModal.modal.modal-sp-fullscreen.in {
  @media (max-width: 657px) {
    background-color: transparent;
    padding: 0 !important;
    top: 50%;
    left: 50%;
    right: initial;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
  }
}
.favoriteModal .modal-dialog.modal- .modal-content {
  border-radius: 6px;
  @media (max-width: 657px) {
    min-height: initial;
    padding: 0;
  }
}
.favoriteModal.modal .modal-dialog.modal- {
  width: fit-content;
  @media (max-width: 657px) {
    min-height: initial;
    height: initial;
  }
}
.favoriteModal_body {
  border-top: 20px solid #f9423a;
  border-radius: 6px;
  padding: 25px;
  text-align: center;
  &.-error {
    width: 460px;
  }
  @media (max-width: 657px) {
    width: 80vw !important;
  }
}
.favoriteModal_message {
  font-size: 16px;
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", メイリオ, Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", Osaka, sans-serif;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 1.5;
  margin-bottom: 10px;
}
.favoriteModal_img {
  height: 150px;
  @media (max-width: 657px) {
    height: 100px;
  }
}
.favoriteModal_btn {
  background: #c6c4c0;
  margin: 30px auto 0;
  height: 35px;
  width: 300px;
  font-weight: bold !important;
  color: #ffffff;
  border-color: transparent !important;
  border-radius: 4px !important;
  display: block !important;
  @media (max-width: 657px) {
    width: 100px;
  }
}
</style>
